const reduxI18nState = {
  languages: [],
  lang: 'Danish',
  translations: {}
}

export function i18nState (state = reduxI18nState, action) {
  switch (action.type) {
    case 'REDUX_I18N_SET_LANGUAGE':
      return {...state, lang: action.lang}
    case 'REDUX_I18N_SET_TRANSLATIONS':
      return {...state, translations: action.translations}
    case 'REDUX_I18N_SET_LANGUAGES':
      return {...state, languages: action.languages}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/language/reducer/index.js